import React, { useCallback } from 'react';
import { ListParams } from '../../types/main';
import { SelectProps } from './types';
import BaseSearchSelect from './BaseSearchSelect';
import ProjectService from '../../services/ProjectService';


const ProjectField = (props: SelectProps) => {

  const defaultParams: ListParams = {
    page_size: 10,
    sort_key: 'updated',
    sort_dir: 'DESC',
  };

  const searchOptionsHandler = useCallback(async (params: ListParams) => {
    const records = await ProjectService.list({ ...defaultParams, ...params});

    return records.items?.map((item) => ({
      label: item.title,
      id: item.id,
    })) || [];
  }, [defaultParams]);

  return (
    <BaseSearchSelect
      searchOptions={searchOptionsHandler}
      {...props}
    />
  );
};


export default ProjectField;
